export class JsonNumberConverter {
    serialize(property) {
        return typeof property === 'string' ? Number(property) : property;
    }
    deserialize(value) {
        return Number(value);
    }
    /* istanbul ignore next */
    collapseArrayWithSingleItem() {
        return false;
    }
}
//# sourceMappingURL=number-converter.js.map